function safeRandomState() {
  try {
    const c = (typeof crypto !== 'undefined' && crypto) ? crypto : ((typeof window !== 'undefined' && window.crypto) ? window.crypto : null)
    if (c && typeof c.randomUUID === 'function') return c.randomUUID()
  } catch { }
  return `st_${Date.now()}_${Math.random().toString(16).slice(2)}_${Math.random().toString(16).slice(2)}`
}

function buildRedirectUri() {
  const env = String(process.env.REACT_APP_NAVER_REDIRECT_URI || '').trim()
  if (env) return env
  if (typeof window === 'undefined') return ''
  return `${window.location.origin}/auth/naver/callback`
}

/**
 * Naver OAuth (Authorization Code Flow) via popup.
 * - response_type=code 로 code/state를 callback query로 받는다.
 * - callback 페이지(`/auth/naver/callback`)는 opener에 postMessage 후 닫힌다.
 */
export function naverLogin({ clientId } = {}) {
  const cid = String(clientId || process.env.REACT_APP_NAVER_CLIENT_ID || '').trim()
  if (!cid) return Promise.reject(new Error('NAVER clientId가 설정되지 않았습니다.'))
  const redirectUri = buildRedirectUri()
  if (!redirectUri) return Promise.reject(new Error('NAVER redirectUri를 결정할 수 없습니다.'))

  const state = safeRandomState()
  const authUrl = (() => {
    const qs = new URLSearchParams({
      response_type: 'code',
      client_id: cid,
      redirect_uri: redirectUri,
      state,
    })
    return `https://nid.naver.com/oauth2.0/authorize?${qs.toString()}`
  })()

  return new Promise((resolve, reject) => {
    let done = false
    let timer = null
    let popup = null

    const cleanup = () => {
      try { window.removeEventListener('message', onMessage) } catch { }
      if (timer) {
        try { clearInterval(timer) } catch { }
        timer = null
      }
    }

    const finish = (err, payload) => {
      if (done) return
      done = true
      cleanup()
      if (popup && !popup.closed) {
        try { popup.close() } catch { }
      }
      if (err) reject(err)
      else resolve(payload)
    }

    const onMessage = (e) => {
      try {
        if (typeof window !== 'undefined' && e.origin !== window.location.origin) return
        const data = e.data || {}
        if (!data || data.type !== 'naver_oauth') return
        if (data.state && String(data.state) !== String(state)) {
          finish(new Error('NAVER state가 일치하지 않습니다.'), null)
          return
        }
        if (data.error) {
          finish(new Error(String(data.error)), null)
          return
        }
        const code = data.code ? String(data.code) : ''
        if (!code) {
          finish(new Error('네이버 code를 받지 못했습니다.'), null)
          return
        }
        finish(null, { code, state, redirectUri })
      } catch (err) {
        finish(err, null)
      }
    }

    window.addEventListener('message', onMessage)
    popup = window.open(authUrl, 'naver_oauth', 'width=480,height=640,noopener,noreferrer')
    if (!popup) {
      cleanup()
      reject(new Error('팝업이 차단되었습니다. 브라우저 팝업 차단을 해제해주세요.'))
      return
    }

    // 사용자가 팝업을 닫았는지 폴링
    timer = setInterval(() => {
      try {
        if (popup.closed) {
          finish(new Error('네이버 로그인을 취소했습니다.'), null)
        }
      } catch { }
    }, 400)
  })
}

